module.exports = __webpack_public_path__ + "img/icon-arrow-left.a3680b5b.svg";